<template>
	<v-container fluid class="mt-4 ml-2">
	  <v-row>
	  	<v-col cols="12">
	  		<div>Reporte de caja por día</div>
	  	</v-col>
	  </v-row>

	  <!-- header para consultar -->
	  <div v-if="visible == false">{{usuario.nomuser}} -- Fecha{{date}}</div>
	  <v-row v-if="visible == true">
	  	<v-col cols="12" sm="6" lg="4">
	  		<v-select
	  		  :items="usuarios"
	  		  v-model="usuario"
	  		  item-text="nomuser"
          item-value="id" 
	  		  label="Seleccionar usuario"
	  		  outlined
	  		  return-object
	  		  dense
	  		  hide-details
	  		></v-select>
	  	</v-col>

	  	<v-col cols="12" sm="4" lg="3">
	      <v-text-field
        	dense
        	hide-details
        	outlined
          v-model="date"
          label="Fecha"
          type="date"
        ></v-text-field>
	    </v-col>

	    <v-col cols="12" sm="6" lg="4" v-if="visible == true">
	    	<v-btn 
	    		color="orange" 
	    		tile
	    		dark 
	    		small
	    		class="mr-2"
	    		@click="consultar()"
	    	>
	    		<v-icon>mdi-refresh</v-icon>
	    	</v-btn>
	    	<v-btn 
	    		color="grey" 
	    		tile
	    		dark 
	    		small
	    		@click="imprimir()"
	    	>
	    		<v-icon>mdi-printer</v-icon>
	    	</v-btn>
	    </v-col>
	  </v-row>

	  <!-- Tipos de movimientos para filtros -->
	  <v-row v-if="visible == true">
	  	<v-col cols="6" sm="4" lg="2" v-for="(movim, i) in tipomovimientos" :key="i">
	  		<v-card :color="movim.color" dark :class="`elevation-${movim.elevation}`" @click="seleccionarTiopoM(i, movim)">
	  			<v-card-text>
	  		  	<v-icon v-text="movim.icon" left></v-icon>{{movim.nommovin}} {{movim.cantidad}}
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Movimientos -->
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<v-card-title class="text-subtitle-1 px-2 py-2">
	  				Cierre de caja
	  			</v-card-title>

    			<v-data-table
	          :headers="headers"
	          :items="movimientos"
	          hide-default-footer
	          fixed-header
	          :items-per-page="length"
	          dense
	          >

	          <template v-slot:item.tipo = "{ item }" > 
			    		<div v-if="item.tipo==1">Entrada</div>
			    		<div v-if="item.tipo==2">Salida</div>
			    		<div v-if="item.tipo==3">Cancelación</div>
			    		<div v-if="item.tipo==4">Devolución</div>
				    </template>

				    <template v-slot:item.tipopago = "{ item }" > 
			    		<div v-if="item.tipopago==1">Efectivo</div>
			    		<div v-if="item.tipopago==2">Cheque</div>
			    		<div v-if="item.tipopago==3">Transferencia</div>
			    		<div v-if="item.tipopago==4">Tarjeta</div>
				    </template>
				    
	          <template v-slot:item.opciones = "{ item }" > 
			    		<v-btn color="success" icon @click="verMovim(item)"><v-icon>mdi-eye</v-icon></v-btn>
				    </template>
	        </v-data-table>
        </v-card>
	  	</v-col>
	  </v-row>

	  <!-- corte de caja reporte de dinero -->
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
          <v-card-title class="text-subtitle-1 px-2 py-2">
	  				Tipo de movimiento
	  			</v-card-title>
    			<v-data-table
	          :headers="headersPago"
	          :items="tipoPagos"
	          hide-default-footer
	          fixed-header
	          :items-per-page="length2"
	          dense
	          >

	          <template v-slot:item.tipo = "{ item }" > 
			    		<div v-if="item.tipo==1">Efectivo</div>
			    		<div v-if="item.tipo==2">Cheque</div>
			    		<div v-if="item.tipo==3">Transferencia</div>
			    		<div v-if="item.tipo==4">Tarjeta</div>
				    </template>
	        </v-data-table>
	        <v-row class="pa-0">
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Total entradas: ({{tipomovimientos[0].cantidad}}) {{totalEntrada}}</div>
	        	</v-col>
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Total salidas : ({{tipomovimientos[1].cantidad}}) {{totalSalida}}</div>
	        	</v-col>
	        </v-row>
	        <v-row class="pa-0">
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Total: {{totalDia}}</div>
	        	</v-col>
	        	<v-col cols="6" class="pa-0">
	        		<div class="ml-4 title" align="left" style="font-size: 14px !important;">Saldo en caja: {{saldoCaja}}</h2></div>
	        	</v-col>
	        </v-row>
	        
        </v-card>
	  	</v-col>
	  </v-row>


	  <!-- Reporte de cortes -->
	  <v-row v-if="visible==true">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
          <v-card-title class="text-subtitle-1 px-2 py-2">
	  				Retiros de efectivo
	  			</v-card-title>
    			<v-data-table
	          :headers="headersRetiro"
	          :items="retiros"
	          hide-default-footer
	          fixed-header
	          :items-per-page="length3"
	          dense
	          >
	        </v-data-table>
	        <div class="mr-6 title" align="right" style="font-size: 14px !important;">Total: {{retirosTotal}}</div>
        </v-card>
	  	</v-col>
	  </v-row>

	  <!-- Grafica -->
	  <v-row v-if="visible == true">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<div id="chartdivv" ref="chartdivv"></div>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Ver movimiento -->
	  <v-row justify="center" v-if="dialogMovim">
      <v-dialog v-model="dialogMovim" persistent max-width="350px" >
        <v-card>
          <v-card-title class="text-subtitle-1">Ver movimiento
          	<v-spacer></v-spacer>
          	<v-btn color="red" icon @click="dialogMovim=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
          	<v-text-field
          	  outlined
          	  label="Folio"
          	  v-model="movim.folio"
          	  dense
          	></v-text-field>

          	<v-text-field
          	  outlined
          	  label="Tipo de pago"
          	  v-model="mtipopago"
          	  dense
          	></v-text-field>
          	<v-text-field
          		type="number"
          	  outlined
          	  label="Total a pagar"
          	  v-model="movim.cantidad"
          	  dense
          	></v-text-field>
          	<v-text-field
          		type="number"
          	  outlined
          	  label="Pago recibído"
          	  v-model="movim.pago"
          	  dense
          	></v-text-field>
          	<v-text-field
          		type="number"
          	  outlined
          	  label="Cambio"
          	  v-model="movim.cambio"
          	  dense
          	></v-text-field>
          	<v-textarea v-model="movim.concepto"  label="concepto" dense outlined></v-textarea>

      			<v-divider></v-divider v-if="movim.tipo != 1 && movim.tipo != 2">

        		<v-col cols="12" sm="6" lg="4" v-if="movim.tipo != 1 && movim.tipo != 2">
	          	<v-text-field
	          	  outlined
	          	  label="Autorizó"
	          	  v-model="movim.nomuser"
	          	  dense
	          	></v-text-field>
        		</v-col>
        		<v-col cols="12" sm="12" lg="8" v-if="movim.tipo != 1 && movim.tipo != 2">
	          	<v-textarea v-model="movim.concepto2"  label="Concepto por cancelación" dense outlined></v-textarea>
        		</v-col>
        		<div>
        			Fecha: {{date}}   Hora: {{movim.hora}}
        		</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
            	color="green" 
            	tile
            	small
            	dark 
            	@click="dialogMovim = false"
            >
          		Aceptar
          	</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>

<script>
	// import * as am4core        from "@amcharts/amcharts4/core";
	// import * as am4charts      from "@amcharts/amcharts4/charts";
	// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
	// am4core.useTheme(am4themes_animated);
	// var numeral = require('numeral');

	import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

	export default{

		components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

			// Visible para impresion
			visible: true,
			totalEntrada:0,
			totalSalida:0,
			totalDia:0,
			// Retiros
			retiros:[],
			retirosTotal:0,
			headersRetiro:[
        {text: 'Hora', value:'hora'},
        {text: 'Cantidad', value:'corte'},
      ],
      length3:5,

			// Movimiento
			dialogMovim: false,
			movim:{},
			mtipopago:'',

			altura: 200,
		 	usuarios:[],
			usuario:{nomuser:'', id:''},

			date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,


      tipomovimientos: [
      	{nommovin:'Entradas',      icon:'mdi-import',         valor:1 ,cantidad:0, elevation: 2, color: 'green'},
      	{nommovin:'Salidas',       icon:'mdi-undo',           valor:2 ,cantidad:0, elevation: 2, color: 'red'},
      	{nommovin:'Cancelaciones', icon:'mdi-close',          valor:3 ,cantidad:0, elevation: 2, color: 'orange'},
      	{nommovin:'Devoluciones',  icon:'mdi-backup-restore', valor:4 ,cantidad:0, elevation: 2, color: 'blue'},
      	{nommovin:'Todos',         icon:'mdi-backup-restore', valor:5 ,cantidad:0, elevation: 12, color: 'grey'},
      ],


      headersPago:[
        {text: 'Movimiento', value:'tipo'},
        {text: 'Real', value:'real'},
        {text: 'Reportado', value:'reportado'},
        {text: 'Diferencia', value:'diferencia'},
      ],
     	tipoPagos:[],
			length: 200,
			length2: 5,


			headers:[
        {text: 'id', value:'idmovim'},
        {text: 'Estatus', value:'tipo'},
        {text: 'Folio', value:'folio'},
        {text: 'Concepto', value:'concepto'},
        {text: 'Total', value:'cantidad'},
        {text: 'Pago', value:'pago'},
        {text: 'Cambio', value:'cambio'},
        {text: 'Autorizó', value:'nomuser'},
        {text: 'Tipo de pago', value:'tipopago'},
        // {text: 'Autorización', value:'autorizacion'},
        // {text: 'Concepto por cancelcacion', value:'concepto2'},
        {text: 'Hora', value:'hora'},
        {text: 'Opciones', value:'opciones'},
      ],

      movimientos:[],
      movimientostemp:[],
      total:0,

      snackbar: false,
      color:'success',
      text:'',

      idcaja:0,

      dataGrafica:[],

      saldoCaja:0,
		}),

		created(){
			this.initialize()
		},
		
		mounted() {
	    this.graficar()
	  },

	  beforeDestroy() {
	    if (this.chart) {
	      this.chart.dispose();
	    }
	  },

		methods:{
			...mapActions('login',['ocultarToolbar']),
			imprimir(){
				var temp = this.tipoPagos
				this.tipoPagos = [temp[0]]

				this.visible = false
				this.headers=[
        {text: 'id', value:'idmovim'},
        {text: 'Estatus', value:'tipo'},
        {text: 'Folio', value:'folio'},
        {text: 'Concepto', value:'concepto'},
        {text: 'Total', value:'cantidad'},
        // {text: 'Pago', value:'pago'},
        // {text: 'Cambio', value:'cambio'},
        // {text: 'Autorizó', value:'nomuser'},
        {text: 'Tipo de pago', value:'tipopago'},
        // {text: 'Autorización', value:'autorizacion'},
        // {text: 'Concepto por cancelcacion', value:'concepto2'},
        // {text: 'Hora', value:'hora'},
        // {text: 'Opciones', value:'opciones'},
      ]
				this.ocultarToolbar(false)
				this.altura = (this.movimientostemp.length * 75.590551181102)
				setTimeout(()=>{ window.print(); }, 1000);
				
				setTimeout(()=>{ 
					this.ocultarToolbar(true), this.initialize(),this.visible = true,this.tipoPagos= temp
					this.headers =[
		        {text: 'id', value:'idmovim'},
		        {text: 'Estatus', value:'tipo'},
		        {text: 'Folio', value:'folio'},
		        {text: 'Concepto', value:'concepto'},
		        {text: 'Total', value:'cantidad'},
		        {text: 'Pago', value:'pago'},
		        {text: 'Cambio', value:'cambio'},
		        {text: 'Autorizó', value:'nomuser'},
		        {text: 'Tipo de pago', value:'tipopago'},
		        // {text: 'Autorización', value:'autorizacion'},
		        // {text: 'Concepto por cancelcacion', value:'concepto2'},
		        {text: 'Hora', value:'hora'},
		        {text: 'Opciones', value:'opciones'},
		      ]

				}, 3000);
			},

			initialize(){
				this.getUsuarios()
			},

			getUsuarios(){
				this.$http.get('user_caja').then(response=>{
					this.usuarios = response.body
				}).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
			},

			seleccionarTiopoM(posicion, valor){
				console.log( valor)
				this.movimientos = []
				for(const i in this.tipomovimientos){
					if(this.tipomovimientos[i].valor == valor.valor){
						this.tipomovimientos[i].elevation = 16
					}else{
						this.tipomovimientos[i].elevation = 2
					}
				}

				for(const i in this.movimientostemp){
					if(valor.valor == 5){
						this.movimientos = this.movimientostemp
					}else{
						if(this.movimientostemp[i].tipo == valor.valor){
							this.movimientos.push(this.movimientostemp[i])
						}
					}
				}
			},



			consultar(){
				this.totalEntrada = 0
				this.totalSalida = 0
				this.totalDia = 0
				this.retiros = []
				this.retirosTotal = 0
				this.saldoCaja = 0
				var dineroSalida = 0
				this.total = 0
				this.tipoPagos = []
				this.movimientos = []
				this.tipomovimientos[0].cantidad = 0
				this.tipomovimientos[1].cantidad = 0
				this.tipomovimientos[2].cantidad = 0
				this.tipomovimientos[3].cantidad = 0
				this.tipomovimientos[4].cantidad = 0
				var payload = {
					id: this.usuario.id,
					fecha: this.date
				}

				this.$http.post('cierre_detalle', payload).then(response=>{
					console.log(response.body)
					this.idcaja = response.body[0].id_caja
					this.tipoPagos = response.body
					this.$http.get('movimientos/' + this.idcaja).then(response=>{
						this.movimientostemp = response.body
						this.movimientos = response.body
						for(const i in this.movimientos){
							if(this.movimientos[i].tipo == 1){
								this.tipomovimientos[0].cantidad += 1
								this.totalEntrada += this.movimientos[i].cantidad
							}
							if(this.movimientos[i].tipo == 2){
								this.tipomovimientos[1].cantidad += 1
								dineroSalida += this.movimientos[i].cantidad
								this.totalSalida += this.movimientos[i].cantidad
							}
							if(this.movimientos[i].tipo == 3){
								this.tipomovimientos[2].cantidad += 1
							}
							if(this.movimientos[i].tipo == 4){
								this.tipomovimientos[3].cantidad += 1
							}

							this.tipomovimientos[4].cantidad += 1
						}

						var efectivo = 0
						var cheque = 0
						var transferencia = 0
						var tarjeta = 0
						var id = 0

						for(const i in this.movimientostemp){
							id += 1
							this.movimientostemp[i].idmovim = id
							if(this.movimientostemp[i].tipo == 1){
								if(this.movimientostemp[i].tipopago == 1){
									efectivo += this.movimientostemp[i].cantidad
								}
								if(this.movimientostemp[i].tipopago == 2){
									cheque += this.movimientostemp[i].cantidad
								}
								if(this.movimientostemp[i].tipopago == 3){
									transferencia += this.movimientostemp[i].cantidad
								}
								if(this.movimientostemp[i].tipopago == 4){
									tarjeta += this.movimientostemp[i].cantidad
								}
							}
						}

						this.altura = ( this.movimientostemp.length * 37 ) + 32
						this.length = this.movimientostemp.length

						this.dataGrafica = [
							{tipodePago: 'Efectivo', cantidad: efectivo},
							{tipodePago: 'Cheque', cantidad: cheque},
							{tipodePago: 'Transferencia', cantidad: transferencia},
							{tipodePago: 'Tarjeta', cantidad: tarjeta},
						]
						this.total = efectivo + cheque + transferencia + tarjeta
						this.total = numeral(this.total).format('0,0.00');

						this.totalDia = this.totalEntrada - this.totalSalida
						this.totalDia = numeral(this.totalDia).format('0,0.00');

						this.totalEntrada = numeral(this.totalEntrada).format('0,0.00');
						this.totalSalida = numeral(this.totalSalida).format('0,0.00');

						this.$http.get('caja.get/' + this.idcaja).then(response=>{
							console.log(response.body)
							this.saldoCaja = response.body.saldoinicial + this.tipoPagos[0].reportado - dineroSalida
							this.saldoCaja = numeral(this.saldoCaja).format('0,0.00');
							this.graficar()
							this.formatos()
							this.$http.post('retiros/' + this.idcaja).then(response=>{
								console.log(response.body)
								this.retiros = response.body
								for(const i in this.retiros){
									this.retirosTotal += this.retiros[i].corte
								}
								this.retirosTotal = numeral(this.retirosTotal).format('0,0.00');
								this.length3 = this.retiros.length

							}).catch( error =>{
			          this.validarErrorDirecto( 'No hay retiros de efectivo' )
			        }).finally( () => { this.cargar = false })
						}).catch( error =>{
		          this.validarErrorDirecto( 'No hay datos' )
		        }).finally( () => { this.cargar = false })

					}).catch( error =>{
	          this.validarErrorDirecto( 'No hay datos' )
	        }).finally( () => { this.cargar = false })
				}).catch( error =>{
          this.validarErrorDirecto( 'No hay datos' )
        }).finally( () => { this.cargar = false })
			},

			formatos(){
				for(const i in this.movimientostemp){
					this.movimientostemp[i].cantidad = numeral(this.movimientostemp[i].cantidad).format('0,0.00');
					this.movimientostemp[i].cambio = numeral(this.movimientostemp[i].cambio).format('0,0.00');
					this.movimientostemp[i].pago = numeral(this.movimientostemp[i].pago).format('0,0.00');
				}

				for(const i in this.tipoPagos){
					this.tipoPagos[i].real = numeral(this.tipoPagos[i].real).format('0,0.00');
					this.tipoPagos[i].reportado = numeral(this.tipoPagos[i].reportado).format('0,0.00');
					this.tipoPagos[i].diferencia = numeral(this.tipoPagos[i].diferencia).format('0,0.00');
				}

				for(const i in this.retiros){
					this.retiros[i].corte = numeral(this.retiros[i].corte).format('0,0.00');
				}
			},

			capturadeError(value){
        this.color = 'error'
        this.text = value
        this.snackbar = true
      },

      graficar(){
      	let chart = am4core.create(this.$refs.chartdivv, am4charts.XYChart);

		    chart.paddingRight = 20;

		    let data = this.dataGrafica
		    

		    chart.data = data;

		    chart.padding(40, 40, 40, 40);

				var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
				categoryAxis.renderer.grid.template.location = 0;
				categoryAxis.dataFields.category = "tipodePago";
				categoryAxis.renderer.minGridDistance = 60;
				categoryAxis.renderer.inversed = true;
				categoryAxis.renderer.grid.template.disabled = true;

				var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
				valueAxis.min = 0;
				valueAxis.extraMax = 0.1;
				//valueAxis.rangeChangeEasing = am4core.ease.linear;
				//valueAxis.rangeChangeDuration = 1500;

				var series = chart.series.push(new am4charts.ColumnSeries());
				series.dataFields.categoryX = "tipodePago";
				series.dataFields.valueY = "cantidad";
				series.tooltipText = "{valueY.value}"
				series.columns.template.strokeOpacity = 0;
				series.columns.template.column.cornerRadiusTopRight = 10;
				series.columns.template.column.cornerRadiusTopLeft = 10;
				//series.interpolationDuration = 1500;
				//series.interpolationEasing = am4core.ease.linear;
				var labelBullet = series.bullets.push(new am4charts.LabelBullet());
				labelBullet.label.verticalCenter = "bottom";
				labelBullet.label.dy = -10;
				labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";

				chart.zoomOutButton.disabled = true;

				// as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
				series.columns.template.adapter.add("fill", function (fill, target) {
				 return chart.colors.getIndex(target.dataItem.index);
				});


				categoryAxis.sortBySeries = series;

		    this.chart = chart;
      },

      verMovim(value){
      	if(value.tipopago == 1){
      		this.mtipopago = 'Efectivo'
      	}
      	if(value.tipopago == 2){
      		this.mtipopago = 'Cheque'
      	}
      	if(value.tipopago == 3){
      		this.mtipopago = 'Transferencia'
      	}
      	if(value.tipopago == 4){
      		this.mtipopago = 'Tarjeta'
      	}
      	this.movim = value
      	this.dialogMovim = true
      }
		}
	}
</script>

<style scoped>
	#chartdivv {
	  width: 100%;
	  height: 500px;
	}

</style>